import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetTemplates, ITemplateReq } from '../models/template.model';

const uri = '/mgmt/template';

export const getTemplates = (): AxiosPromise<IGetTemplates> => {
  return axios.get(uri);
};

export const createTemplate = (data: ITemplateReq): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateTemplate = (templateCode: number, data: ITemplateReq): AxiosPromise => {
  return axios.put(`${uri}/${templateCode}`, data);
};

export const deleteTemplate = (templateCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${templateCode}`);
};
